// extracted by mini-css-extract-plugin
module.exports = {"dark-grey":"#9E9C9C","markerContainer":"Marker_markerContainer__OuZ_C","marker":"Marker_marker__T2g2i","markerSvg":"Marker_markerSvg__30gl3"};